




// src/components/Reels.js
import React, { useEffect, useRef } from "react";
import "../css-coding/reels.css";
import leftArrow from "../assets/arrow-1.png";
import rightArrow from "../assets/arrow-2.png";
import Cimg from "../assets/center-img3.png";

// ---- Short form videos ----
import sb1 from "../assets/BASIC 01.mp4";
import sb2 from "../assets/BASIC 02.mp4";
import sb3 from "../assets/BASIC 03.mp4";
import sb4 from "../assets/BASIC 04.mp4";
import sb5 from "../assets/BASIC 05.mp4";
import sb6 from "../assets/BASIC 06.mp4";

import si1 from "../assets/INTERMEDIATE 01.mp4";
import si2 from "../assets/INTERMEDIATE 02.mp4";
import si3 from "../assets/INTERMEDIATE 03.mp4";
import si4 from "../assets/INTERMEDIATE 04.mp4";
import si5 from "../assets/INTERMEDIATE 05.mp4";
import si6 from "../assets/INTERMEDIATE 06.mp4";

import sa1 from "../assets/ADVANCED 01.mp4";
import sa2 from "../assets/ADVANCED 02.mp4";
import sa3 from "../assets/ADVANCED 03.mp4";
import sa4 from "../assets/ADVANCED 04.mp4";
import sa5 from "../assets/ADVANCED 05.mp4";
import sa6 from "../assets/ADVANCED 06.mp4";

// ---- Long form videos ----
import lm1 from "../assets/LONG FORM MOTION GRAPHIC 01.mp4";
import lm2 from "../assets/LONG FORM MOTION GRAPHIC 02.mp4";
import lm3 from "../assets/LONG FORM MOTION GRAPHIC 03.mp4";
import lm4 from "../assets/LONG FORM MOTION GRAPHIC 04.mp4";

import le1 from "../assets/LONG FORM EXPLAINER 01.mp4";
import le2 from "../assets/LONG FORM EXPLAINER 02.mp4";
import le3 from "../assets/LONG FORM EXPLAINER 03.mp4";
import le4 from "../assets/LONG FORM EXPLAINER 04.mp4";

import ls1 from "../assets/LONG FORM STORYTELLING 01.mp4";
import ls2 from "../assets/LONG FORM STORYTELLING 02.mp4";
import ls3 from "../assets/LONG FORM STORYTELLING 03.mp4";
import ls4 from "../assets/LONG FORM STORYTELLING 04.mp4";

/*
  Key ideas:
  - Short form videos use the "reel" class (keep original layout)
  - Long form videos use the "long-video" class (two-per-row grid)
  - renderVideos accepts a videoClassName so we don't accidentally mix classes
  - IntersectionObserver plays/pauses based on visibility (threshold 0.5)
  - No autoPlay attribute: play() is called programmatically (videos remain muted)
*/

function Reels() {
  // total videos = 18 short + 12 long = 30
  const videoRefs = useRef(Array(30).fill(null));

  useEffect(() => {
    const options = { threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          // play might return a promise (browsers can block) — ignore errors
          video.play?.().catch(() => {});
        } else {
          try {
            video.pause();
          } catch (e) {}
        }
      });
    }, options);

    // observe only non-null refs
    videoRefs.current.forEach((v) => {
      if (v) observer.observe(v);
    });

    return () => observer.disconnect();
  }, []);

  const renderVideos = (sources, startIndex, videoClassName = "reel") =>
    sources.map((src, i) => (
      <video
        key={`${videoClassName}-${startIndex + i}-${src}`}
        ref={(el) => (videoRefs.current[startIndex + i] = el)}
        className={videoClassName}
        src={src}
        muted
        loop
        playsInline
        preload="metadata"
      />
    ));

  return (
    <div className="reels">
      {/* Short Form - Starter Pack */}
      <div className="short-form">
        <h4 className="sf">Short Form Content</h4>
        <p className="sp">( Starter Pack )</p>
        <div className="reels-container">{renderVideos([sb1, sb2, sb3, sb4, sb5, sb6], 0, "reel")}</div>
      
      </div>

      {/* Short Form - Engaging Pack */}
      <div className="short-form">
        <h4 className="sf">Short Form Content</h4>
        <p className="sp">( Engaging Pack )</p>
        <div className="reels-container">{renderVideos([si1, si2, si3, si4, si5, si6], 6, "reel")}</div>
      </div>
<br></br>
      {/* Short Form - Top Notch Pack */}
      <div className="short-form">
        <h4 className="sf">Short Form Content</h4>
        <p className="sp">( Top Notch Pack )</p>
        <div className="reels-container">{renderVideos([sa1, sa2, sa3, sa4, sa5, sa6], 12, "reel")}</div>
      </div>

      {/* Center Image / CTA */}
      <div>
        <a
          href="https://api.whatsapp.com/send/?phone=916382765055&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Cimg} alt="Sample" className="center-img" />
        </a>
      </div>

      <br>
      </br>
      <br></br>

      {/* Long Form - Motion Graphics */}
      <div className="short-form">
        <h4 className="sf">Long Form Content</h4>
        <p className="sp">( Motion Graphics )</p>
        <div className="long-videos-container">{renderVideos([lm1, lm2, lm3, lm4], 18, "long-video")}</div>
        
      </div>

      {/* Long Form - Explainer Promos */}
      <div className="short-form">
        <h4 className="sf">Long Form Content</h4>
        <p className="sp">( Explainer Promos )</p>
        <div className="long-videos-container">{renderVideos([le1, le2, le3, le4], 22, "long-video")}</div>
      </div>

      {/* Long Form - Storytelling */}
      <div className="short-form">
        <h4 className="sf">Long Form Content</h4>
        <p className="sp">( Storytelling )</p>
        <div className="long-videos-container">{renderVideos([ls1, ls2, ls3, ls4], 26, "long-video")}</div>
      </div>
    </div>
  );
}

export default Reels;
